import { useEffect, useState } from "react";
import axios from "axios";

// Upper end of a filter slider (InputSliderRange): the listing's highest value for `field`,
// fetched as the first row sorted descending, rounded up to `roundTo`. `fallback` until it
// loads, or when the request fails / the listing is empty.
export default function useRangeMax(endpoint, field, { sortField = field, params = {}, roundTo = 100, fallback = 1000 } = {}) {
    const [max, setMax] = useState(fallback);
    const paramsKey = JSON.stringify(params);

    useEffect(() => {
        if (!endpoint) return;
        axios.get(endpoint, {
            params: { ...JSON.parse(paramsKey), page: 0, size: 1, sortField, sortDirection: 'desc' },
            withCredentials: true,
        })
            .then(({ data }) => {
                const top = Number((data.content ?? data)?.[0]?.[field]);
                if (top > 0) setMax(Math.ceil(top / roundTo) * roundTo);
            })
            .catch(() => {});
    }, [endpoint, field, sortField, paramsKey, roundTo]);

    return max;
}
